import React, { useEffect, useState } from 'react'
import { I18n } from 'react-redux-i18n'
import { Button, Card, CardBody, Col, Collapse, Input, Label, Row } from 'reactstrap'
import { notifySale } from 'redux/actions/marketing'
import './styles.scss'
import { useDispatch } from 'react-redux'
import _get from 'lodash.get'

import { CURRENCY_LIST } from 'constants/index'
import { withModule } from 'hocs'
import { getStaticImage } from 'utils/statics'
import Nixi1Spinner from 'components/Nixi1Spinner'

const PluginMarketingSales = (props) => {
  const { user } = props

  const dispatch = useDispatch()
  const [open, setOpen] = useState(false)
  const [loadingCreate, setLoadingCreate] = useState(false)
  const [dataSale, setDataSale] = useState({
    selectCampaign: '',
    reference: '',
    concept: '',
    price: '',
    currency: 'EUR',
  })
  const [formInvalid, setFormInvalid] = useState(false)
  const [formInvalidNotSale, setFormInvalidNotSale] = useState(false)

  useEffect(() => {
    let checkInvalid = false
    let formNotSale = false
    // verificar formulario
    for (const keyValue in dataSale) {
      if (!dataSale[keyValue]) {
        checkInvalid = true
      }
    }

    if (!dataSale['selectCampaign'] ) {
      formNotSale = true
    }

    setFormInvalid(checkInvalid)
    setFormInvalidNotSale(formNotSale)
  }, [dataSale, user._id])

  useEffect(() => {
    resetForm()
  }, [user._id])

  const listCampaigns = _get(user, 'campaigns', []).map((el) => {
    return { value: el.id, label: el.name }
  })

  const toggle = () => {
    setOpen(user.isRemoveByUser ? false : !open)
  }

  const resetForm = () => {
    setDataSale({
      selectCampaign: '',
      reference: '',
      concept: '',
      price: '',
      currency: 'EUR',
    })

    setLoadingCreate(false)
  }

  const createSale = (notSale) => {
    setLoadingCreate(true)
    const id = dataSale.selectCampaign
    const body = {
      userId: user._id,
      reference: dataSale.reference,
      text: dataSale.concept,
      notSale: notSale,
      price: {
        value: +dataSale.price,
        currency: dataSale.currency,
      },
    }

    dispatch(notifySale(id, body))
      .then((result) => {
        resetForm()
      })
      .catch((error) => {
        resetForm()
      })
  }

  const handleInputChange = (event) => {
    setDataSale({
      ...dataSale,
      [event.target.name]: event.target.value,
    })
  }

  return (
    <div className={`plugin-sales-card ${user.isRemoveByUser ? 'disabled' : ''}`}>
      <div className='title-container'>
        <div className='title'>
          <figure>
            <img src={getStaticImage('/icons/orange-brand/icon-tickets-dark.svg')} alt='Sales' />
          </figure>
          <p>
            {I18n.t('plugin_marketing_sales_title')}
          </p>
        </div>
        <div className='action-buttons-container'>
          <i className={`fa fa-chevron-${open ? 'up' : 'down'}`} onClick={toggle} />
        </div>
      </div>

      <Collapse isOpen={open}>
        <div className='separator' />
        <Card className='mt-3 content-container'>
          <CardBody>
            <Row className='mt-3'>
              <Col>
                <Label for='select_campaign' className='font-weight-bold'>
                  {I18n.t('dashboard_campaigns')}
                </Label>
                <Input onChange={handleInputChange} type='select' name='selectCampaign' value={dataSale.selectCampaign} id='select_campaign' required>
                  <option value='' />
                  {listCampaigns.map((el, idx) => {
                    return (
                      <option key={el.value + idx} value={el.value}>
                        {el.label}
                      </option>
                    )
                  })}
                </Input>
              </Col>
            </Row>

            <Row className='mt-3'>
              <Col>
                <Label for='reference' className='font-weight-bold'>
                  {I18n.t('plugin_marketing_sales_reference')}
                </Label>
                <Input type='text' required id='reference' value={dataSale.reference} name='reference' onChange={handleInputChange} />
              </Col>
            </Row>

            <Row className='mt-3'>
              <Col>
                <Label for='description' className='font-weight-bold'>
                  {I18n.t('dashboard_free-text')}
                </Label>
                <Input type='textarea' required id='concept' value={dataSale.concept} name='concept' onChange={handleInputChange} />
              </Col>
            </Row>

            <Row className='mt-3'>
              <Col>
                <Label for='price' className='font-weight-bold'>
                  {I18n.t('plugin_marketing_sales_value')}
                </Label>
                <Input type='number' required id='price' value={dataSale.price} name='price' min={0} onChange={handleInputChange} />
              </Col>
            </Row>

            <Row className='mt-3'>
              <Col>
                <Label for='currency' className='font-weight-bold'>
                  {I18n.t('dashboard_currency')}
                </Label>
                <Input onChange={handleInputChange} type='select' name='currency' value={dataSale.currency} id='currency' required>
                  {CURRENCY_LIST.map((el) => {
                    return (
                      <option key={el.value} value={el.value}>
                        {el.label}
                      </option>
                    )
                  })}
                </Input>
              </Col>
            </Row>

            <Row className='mt-3'>
              {loadingCreate ? (<Col className='text-right'>
                <Nixi1Spinner height='23px' width='23px'/>
              </Col>
              ) : (
                <Col className='d-flex justify-content-between'>
                  <Button className='mt-3' color='primary' disabled={listCampaigns.length ? formInvalidNotSale : true} onClick={() => createSale(true)}>
                    {I18n.t('plugin_marketing_not_sales_notify_btn')}
                  </Button>

                  <Button className='mt-3' color='primary' disabled={listCampaigns.length ? formInvalid : true} onClick={() => createSale(false)}>
                    {I18n.t('plugin_marketing_sales_notify_btn')}
                  </Button>
                </Col>
              )}
            </Row>
          </CardBody>
        </Card>
      </Collapse>
    </div>
  )
}

export default withModule(PluginMarketingSales, 'crmMarketing')
